import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientContractPage from "@/pages/client/ClientContractPage";

export const Route = createFileRoute("/client/contracts/$contractId/")({
  head: () => pageHead("Client · Contracts", "AKIVA client · contracts portal.", "/client/contracts/$contractId", true),
  component: ClientContractPage,
});
